import { render, staticRenderFns } from "./midjourney.vue?vue&type=template&id=600b46e8&lang=pug&"
import script from "./midjourney.vue?vue&type=script&lang=js&"
export * from "./midjourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports